// import { get } from "lodash";

export default {
  selectDashboardPromotions: (state) => state.dashboardPromotions.dashboardPromotions,

  selectSelectedDashboardPromotion: (state) => state.dashboardPromotions.selectedDashboardPromotion,

  selectDashboardCarouselPromotion: (state) => state.dashboardPromotions.dashboardPromotions.promotions,
};
